// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../types";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TeamEventsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type TeamEventsQuery = {
  __typename?: "Query";
  getEventsByUsersTeams?: Array<{
    __typename?: "Event";
    ID: number;
    UUID: string;
    name: string;
    status: Types.EventStatus;
    fromDateTime: string;
    toDateTime: string;
    location: string;
    requestedToBookAt?: string | null;
    guest: {
      __typename?: "User";
      ID: number;
      lastName: string;
      firstName: string;
    };
    team?: { __typename?: "Team"; ID: number; name?: string | null } | null;
  } | null> | null;
};

export const TeamEventsDocument = gql`
  query TeamEvents {
    getEventsByUsersTeams {
      ID
      UUID
      name
      status
      fromDateTime
      toDateTime
      location
      requestedToBookAt
      guest {
        ID
        lastName
        firstName
      }
      team {
        ID
        name
      }
    }
  }
`;

export function useTeamEventsQuery(
  options?: Omit<Urql.UseQueryArgs<TeamEventsQueryVariables>, "query">
) {
  return Urql.useQuery<TeamEventsQuery>({
    query: TeamEventsDocument,
    ...options,
  });
}
